module.exports = __webpack_public_path__ + "static/media/Walk-through_Tasks_5.1d0808c2.jpg";